'use client';

import { c as _c } from "react/compiler-runtime";
import { Bug } from 'lucide-react';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
type TErrorProps = {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
};
const Error = t0 => {
  const $ = _c(33);
  const {
    reset
  } = t0;
  const t = useTranslations("Pages.Error");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Bug className="size-30 md:size-64 text-destructive" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("Title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <h1 className="text-xl md:text-4xl font-bold text-center">{t2}</h1>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("Subtitle");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <h2 className="text-lg md:text-2xl font-semibold text-center">{t4}</h2>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== reset) {
    t6 = () => reset();
    $[9] = reset;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("TryAgain");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("TryAgain");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = <Button size="lg" className="md:text-lg font-heading uppercase tracking-wider" variant="destructive" onClick={t6} aria-label={t7}>{t8}</Button>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("GoHome");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("GoHome");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <Link href="/">{t11}</Link>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12) {
    t13 = <Button asChild={true} size="lg" className="md:text-lg" variant="vintageNav" aria-label={t10}>{t12}</Button>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t3 || $[30] !== t5 || $[31] !== t9) {
    t14 = <Card className="mx-auto  w-5/6 md:w-3/5 h-11/12 bg-transparent border-none shadow-none rounded-none"><CardContent className="flex flex-col md:pt-4 space-y-8 items-center">{t1}{t3}{t5}{t9}{t13}</CardContent></Card>;
    $[28] = t13;
    $[29] = t3;
    $[30] = t5;
    $[31] = t9;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
};
export default Error;